<div class="filter-modal-container">
  <div class="filter-header">Filters</div>
  <div class="filter-container">
    <form [formGroup]="filterForm" class="filter-form">
      <ng-container *ngIf="openForm">
        <emerald-dropdown
          [label]="'Reporting Manager'"
          [options]="reportingManagerOptions"
          [outlined]="true"
          [isValid]="true"
          formControlName="reportingManager"
          [preSelectedLabel]="'label'"
          [preSelectedValue]="'value'"
        ></emerald-dropdown>

        <emerald-dropdown
          [label]="'LoB'"
          [options]="lobOptions"
          [outlined]="true"
          [isValid]="true"
          formControlName="lob"
          [preSelectedLabel]="'label'"
          [preSelectedValue]="'value'"
        ></emerald-dropdown>

        <emerald-dropdown
          [label]="'Location'"
          [options]="locationOptions"
          [outlined]="true"
          [isValid]="true"
          formControlName="location"
          [preSelectedLabel]="'label'"
          [preSelectedValue]="'value'"
        ></emerald-dropdown>
      </ng-container>

      <ng-container actions>
        <div class="button-container">
          <emerald-button
            [label]="'Reset'"
            [size]="'Small'"
            [type]="'Secondary'"
            (onClick)="reset()"
          ></emerald-button>
          <emerald-button
            [label]="'Apply'"
            [type]="'Primary'"
            (onClick)="opened = false; apply()"
          ></emerald-button>
        </div>
      </ng-container>
    </form>
  </div>
</div>
